export default "__VITE_ASSET__bdt05WFX__"